import { Box, Grid, Typography } from "@mui/material";
import { useMemo } from "react";

export default function TemplateOpcoes({
    title,
    color,
    items
}: TemplateOpcoesProps) {

    const todosDasabilitados = useMemo(() => {
        return items.every(item => item.disabled)
    }, [items])

    return (
        <Grid size={{xs:12}}>
            <Typography
                {...{ color }}
                fontWeight='bold'
                variant="subtitle1"
                mb={0.6}
                ml={0.3}
                sx={{ opacity: todosDasabilitados ? 0.4 : "unset" }}
            >
                {title}
            </Typography>

            <Box>
                {
                    items.map((item, index) => {
                        const itemHab = !item.disabled

                        return (
                            <Box
                                key={index}
                                gap={1}
                                p={0.3}
                                display="flex"
                                alignItems="center"
                                onClick={itemHab ? item.action : () => { }}
                                sx={{
                                    cursor: itemHab ? "pointer" : "default",
                                    transition: "0.2s",
                                    "&:hover": {
                                        bgcolor: itemHab ? "rgba(0,0,0,0.05)" : "unset"
                                    }
                                }}
                            >
                                {!item.icon && <Box width={13} height={19.5} />}
                                {item.icon && <Typography color={color} fontSize="small" sx={{ opacity: item.disabled ? 0.3 : "unset" }}>{item.icon}</Typography>}
                                <Typography color={color} variant="subtitle2" sx={{ opacity: item.disabled ? 0.4 : "unset" }}>{item.label}</Typography>
                            </Box>
                        )
                    })
                }
            </Box>
        </Grid>
    )
}

interface TemplateOpcoesProps {
    title: string;
    color: string;
    items: Array<{
        label: string,
        icon?: JSX.Element,
        action: () => void,
        disabled?: boolean
    }>
}